export default __webpack_public_path__ + "static/media/graph.c6647810.svg";